import styled from '@emotion/styled'

export const IconStyled = styled('svg')({
    maxWidth: '100%',
  },
  props => ({
    transform: props.rotate && `rotate(${props.rotate})`,
  }),
);